import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, Telegram2Icon } from '@blade/ui-kit'
import { openSupportChatAction } from '@root/features/support'
import { useTranslation } from '@root/shared/localization'

export const AuthHelp = () => {
  const { t } = useTranslation()

  const openSupportChart = useAction(openSupportChatAction)

  return (
    <Root>
      <Text>{t('auth.forget-password')}</Text>
      <HelpButton
        onClick={openSupportChart}
        variant="secondary"
        size="m"
        radius="rounded"
        iconLeft={<Telegram2Icon />}
      >
        {t('common.get_help').toUpperCase()}
      </HelpButton>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;

  gap: 12px;

  margin-bottom: 10px;
`

const Text = styled.span`
  color: var(--textA-9);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`

const HelpButton = styled(Button)`
  border: 1px solid var(--backgroundA-4);
  color: var(--text-12);

  justify-content: center;
  align-items: center;
  text-align: center;

  border-radius: 8px;
  height: 32px;
  padding: 0px 12px;
  gap: 6px;
  flex-shrink: 0;

  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`
